import { React, useState, useEffect, createContext, useMemo, useRef } from "react";
import request from "../../../../Helpers/API";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment, FormControl, InputLabel, Select } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";
import { FormatMoney } from "../../../../Helpers/FormatNumber";

export const AgregarMontoGarantiaModal = ({ open, onClose, idEdit, onExecute }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [infoGarantia, setInfoGarantia] = useState({
        modelo: "",
        precio_original: 0,
        precio_ajustado: 0,
        precio_fin_garantia: 0,
        inicio_vigencia: "",
        vigencia: ""
    });

    useEffect(() => {
        if (idEdit !== 0) {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`DashboardPostventa/ObtenerPreciosGarantias?id=${idEdit}`)
                .then((result) => {

                    const formatearFecha = (fechaStr) => {
                        if (!fechaStr) return '';

                        const [fecha] = fechaStr.split(' '); // "08/31/2025"
                        const [mes, dia, anio] = fecha.split('/'); // ["08", "31", "2025"]
                        return `${anio}-${mes}-${dia}`; // "2025/08/31"
                    };

                    setInfoGarantia({
                        ...infoGarantia,
                        modelo: result.modelo,
                        precio_original: result.venta_temprana,
                        precio_ajustado: result.venta_tardia,
                        precio_fin_garantia: result.venta_fin_garantia,
                        inicio_vigencia: formatearFecha(result.fecha_inicio),
                        vigencia: formatearFecha(result.fecha_fin),
                    })
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("FACTURACION", JSON.stringify(error), "error");
                });
        }
    }, [open]);

    const guardarModelo = () => {
        // if (infoGarantia.modelo === "" || infoGarantia.modelo === null || infoGarantia.modelo === undefined) {
        //     Swal.fire({
        //         title: "GARANTIAS",
        //         text: "Debe escribir el Modelo de la garantia",
        //         icon: "warning",
        //         customClass: {
        //             container: "mi-superpoop",
        //         },
        //     });
        //     return;
        // }

        // if (infoGarantia.precio_original === "" || infoGarantia.precio_original === null || infoGarantia.precio_original === undefined || infoGarantia.precio_original <= 0) {
        //     Swal.fire({
        //         title: "GARANTIAS",
        //         text: "Debe ingresar un precio mayor a 0",
        //         icon: "warning",
        //         customClass: {
        //             container: "mi-superpoop",
        //         },
        //     });
        //     return;
        // }

        // if (infoGarantia.precio_ajustado < 0) {
        //     Swal.fire({
        //         title: "GARANTIAS",
        //         text: "Debe ingresar un precio de promoción mayor a 0",
        //         icon: "warning",
        //         customClass: {
        //             container: "mi-superpoop",
        //         },
        //     });
        //     return;
        // }

        // if (infoGarantia.precio_ajustado > 0 && infoGarantia.inicio_vigencia === '' || infoGarantia.precio_ajustado > 0 && infoGarantia.inicio_vigencia === null || infoGarantia.precio_ajustado > 0 && infoGarantia.inicio_vigencia === undefined) {
        //     Swal.fire({
        //         title: "GARANTIAS",
        //         text: "Debe ingresar una inicio para la promoción",
        //         icon: "warning",
        //         customClass: {
        //             container: "mi-superpoop",
        //         },
        //     });
        //     return;
        // }

        // if (infoGarantia.precio_ajustado > 0 && infoGarantia.vigencia === '' || infoGarantia.precio_ajustado > 0 && infoGarantia.vigencia === null || infoGarantia.precio_ajustado > 0 && infoGarantia.vigencia === undefined) {
        //     Swal.fire({
        //         title: "GARANTIAS",
        //         text: "Debe ingresar una vigencia para el precio ajustado",
        //         icon: "warning",
        //         customClass: {
        //             container: "mi-superpoop",
        //         },
        //     });
        //     return;
        // }

        setLoader({ ...loader, mostrar: true });
        const post = {
            idprecio:idEdit,
            modelo: infoGarantia.modelo,
            venta_temprana: infoGarantia.precio_original,
            venta_tardia: infoGarantia.precio_ajustado,
            venta_fin_garantia: infoGarantia.precio_fin_garantia,
            fecha_inicio: infoGarantia.inicio_vigencia,
            fecha_fin: infoGarantia.vigencia
        }
        request
            .post(`DashboardPostventa/ActualizarPrecioGarantia`, post)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                onClose();
                await Swal.fire({
                    title: "GARANTIAS",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                setInfoGarantia({
                    ...infoGarantia,
                    modelo: "",
                    precio_original: 0,
                    precio_ajustado: 0,
                    inicio_vigencia: "",
                    vigencia: ""
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("GARANTIAS", JSON.stringify(error), "error");
            });
    };
console.log(infoGarantia)
    const handleDateChange = (e) => {
        setInfoGarantia({ ...infoGarantia, vigencia: e.target.value });
    };

    const handleDateInicioChange = (e) => {
        setInfoGarantia({ ...infoGarantia, inicio_vigencia: e.target.value });
    };

    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="modelos-modal-formulario">
                    <div className="modelos-modal-plantilla">
                        <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                            <PlantillaScreen
                                titulo={"CONFIGURAR GARANTIA DE MODELO"}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                <div className={`modelos-modal-agregar-convenio`}>
                                    <div className="modelos-modal-agregar-convenio-container">
                                        <TextField
                                            id="outlined-multiline-static"
                                            label="Modelo"
                                            size="small"
                                            value={infoGarantia.modelo}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const regex = /^[a-zA-Z0-9ñÑ.,\-#$% ]*$/;

                                                if (regex.test(value)) {
                                                    setInfoGarantia({
                                                        ...infoGarantia,
                                                        modelo: value,
                                                    });
                                                }
                                            }}
                                            sx={{
                                                mt: 2,
                                                [`@media (max-height:499px)`]: {
                                                    '& .MuiInputBase-root': {
                                                        height: '28px',
                                                    },
                                                    '& input': {
                                                        padding: '4px 6px',
                                                    },
                                                },
                                            }}
                                            fullWidth
                                        />
                                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                            <TextField
                                                label="Precio Venta Temprana"
                                                size="small"
                                                fullWidth
                                                value={infoGarantia.precio_original}
                                                onChange={(e) => {
                                                    const valor = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(valor)) {
                                                        setInfoGarantia({
                                                            ...infoGarantia,
                                                            precio_original: valor,
                                                        });
                                                    }
                                                }}
                                                sx={{
                                                    height: '40px',
                                                    [`@media (max-height:499px)`]: {
                                                        '& .MuiInputBase-root': {
                                                            height: '28px',
                                                        },
                                                        '& input': {
                                                            padding: '6px 8px',
                                                        },
                                                    },
                                                }}
                                            />
                                            <TextField
                                                label="Precio Venta Tardia"
                                                size="small"
                                                fullWidth
                                                value={infoGarantia.precio_ajustado}
                                                onChange={(e) => {
                                                    const valor = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(valor)) {
                                                        setInfoGarantia({
                                                            ...infoGarantia,
                                                            precio_ajustado: valor,
                                                        });
                                                    }
                                                }}
                                                sx={{
                                                    height: '40px',
                                                    '& .MuiInputBase-root': {
                                                        height: '40px',
                                                    },
                                                    '& input': {
                                                        padding: '10px',
                                                    },
                                                }}
                                            />
                                            <TextField
                                                label="Precio Fin de Garantia"
                                                size="small"
                                                fullWidth
                                                value={infoGarantia.precio_fin_garantia}
                                                onChange={(e) => {
                                                    const valor = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(valor)) {
                                                        setInfoGarantia({
                                                            ...infoGarantia,
                                                            precio_fin_garantia: valor,
                                                        });
                                                    }
                                                }}
                                                sx={{
                                                    height: '40px',
                                                    '& .MuiInputBase-root': {
                                                        height: '40px',
                                                    },
                                                    '& input': {
                                                        padding: '10px',
                                                    },
                                                }}
                                            />

                                        </Box>
                                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                            <TextField
                                                id="vigencia"
                                                label="Inicio de promoción"
                                                type="date"
                                                size="small"
                                                fullWidth
                                                value={infoGarantia.inicio_vigencia}
                                                onChange={handleDateInicioChange}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{
                                                    height: '40px',
                                                    '& .MuiInputBase-root': {
                                                        height: '40px',
                                                    },
                                                    '& input': {
                                                        padding: '10px',
                                                    },
                                                }}
                                            />
                                            <TextField
                                                id="vigencia"
                                                label="Vigencia"
                                                type="date"
                                                size="small"
                                                fullWidth
                                                value={infoGarantia.vigencia}
                                                onChange={handleDateChange}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{
                                                    height: '40px',
                                                    '& .MuiInputBase-root': {
                                                        height: '40px',
                                                    },
                                                    '& input': {
                                                        padding: '10px',
                                                    },
                                                }}
                                            />

                                        </Box>
                                    </div>
                                    <div className="modelos-modal-buttons">
                                        <button
                                            className="modelos-modal-button-guardar"
                                            onClick={() => guardarModelo()}
                                        >
                                            Guardar
                                        </button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
};